var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 11.8333C8.5 11.5233 8.5 11.3683 8.53407 11.2412C8.62654 10.8961 8.89609 10.6265 9.24118 10.5341C9.36835 10.5 9.52334 10.5 9.83333 10.5H11.1667C11.4767 10.5 11.6317 10.5 11.7588 10.5341C12.1039 10.6265 12.3735 10.8961 12.4659 11.2412C12.5 11.3683 12.5 11.5233 12.5 11.8333V12.5C12.5 13.6046 11.6046 14.5 10.5 14.5C9.39543 14.5 8.5 13.6046 8.5 12.5V11.8333Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4 12H13.5826C14.8668 12 15.5089 12 16.0556 11.8842C17.638 11.549 18.929 10.5207 19.4939 9.14553C19.6891 8.67043 19.7687 8.09552 19.928 6.9457C19.9878 6.51405 20.0177 6.29823 19.989 6.12169C19.9052 5.60754 19.4932 5.18638 18.9381 5.04764C18.7475 5 18.5065 5 18.0244 5H2.97562C2.49351 5 2.25245 5 2.06187 5.04764C1.50682 5.18638 1.09477 5.60754 1.01104 6.12169C0.982286 6.29823 1.01219 6.51405 1.07198 6.9457C1.23128 8.09552 1.31092 8.67043 1.50609 9.14553C2.071 10.5207 3.36198 11.549 4.94436 11.8842C5.49105 12 6.13318 12 7.41743 12H8.6",
    stroke: "#292D32",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2 10V12C2 15.7712 2 17.6569 3.10649 18.8284C4.21297 20 5.99383 20 9.55556 20H11.4444C15.0062 20 16.787 20 17.8935 18.8284C19 17.6569 19 15.7712 19 12V10",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14 5L13.9227 4.64679C13.5377 2.88673 13.3452 2.00671 12.8869 1.50335C12.4286 1 11.8199 1 10.6023 1H10.3977C9.18014 1 8.57139 1 8.11309 1.50335C7.65478 2.00671 7.46228 2.88673 7.07727 4.64679L7 5",
    stroke: "#292D32",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleBusiness);
export default __webpack_public_path__ + "static/media/ToggleBusiness.b43f6844ea1c9b98be5aabf68f039e48.svg";
export { ForwardRef as ReactComponent };